/**
 * Identity Module - Role Constants
 *
 * Определяет базовые системные роли модуля Identity.
 * Используется для типизации, проверок прав и сидов.
 */

export const IDENTITY_ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

/**
 * Определения ролей для сидов и UI
 */
export const IDENTITY_ROLE_DEFS = [
  {
    role_code: IDENTITY_ROLES.ADMIN,
    name: 'admin',
    description: 'System Administrator - Full access to all features',
    is_active: true,
  },
  {
    role_code: IDENTITY_ROLES.USER,
    name: 'user',
    description: 'Regular User - Basic access to own profile',
    is_active: true,
  },
] as const;

/**
 * TypeScript тип для ролей Identity
 */
export type IdentityRole = (typeof IDENTITY_ROLES)[keyof typeof IDENTITY_ROLES];

/**
 * Есть ли среди ролей глобальный ADMIN.
 *
 * Единая проверка для серверных точек, доступных только администратору
 * (админские RPC-функции identity: их RBAC не проверяет, роль смотрит сама функция).
 * Fail-secure: нет ролей (нет пользователя в контексте) → false.
 */
export function hasAdminRole(roles: readonly string[] | null | undefined): boolean {
  if (!roles) return false;
  return roles.includes(IDENTITY_ROLES.ADMIN);
}

/**
 * Тип для элемента массива IDENTITY_ROLE_DEFS
 */
export type IdentityRoleDef = (typeof IDENTITY_ROLE_DEFS)[number];
